import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { getThemeColor, theme } from '@ezugi/ui/theme';

const { typography, tints } = theme;

const H_PADDING = 16;
const V_PADDING = SIZES.PADDING;

const pbByScroll = ({ hasScroll = false }) => (hasScroll ? 10 : 0);

export const StyledTable = styled.table`
  font-size: 12px;
  font-family: ${typography.font}, sans-serif;
  background: ${getThemeColor('background')};
  color: ${getThemeColor('foreground')};
  padding: 0;
  padding-bottom: ${pbByScroll}px;

  tr {
    height: 28px;
    padding: 0;
  }

  th {
    font-weight: normal;
    text-align: center;
  }

  td,
  th {
    padding: 0 ${H_PADDING}px;
  }
  tr td {
    text-align: center;
  }

  tr td:first-child,
  tr th:first-child {
    text-align: left;
  }
`;

export const mobileStyles = css`
  thead {
    background-color: rgba(0, 0, 0, ${tints.secondary});
  }
  tbody {
    td {
      padding: ${V_PADDING}px ${H_PADDING}px;
    }
  }
`;
